/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// eslint-disable-next-line jira/import-whitelist
import fetchIssueGiraData from '@jira/issue__fetch-services/src/fetchIssueGiraData.tsx';
import { createResourceError } from '@jira/router-resources__utils/src/createResourceError.tsx';
import { getIssueKey } from '@jira/router-resources__utils/src/getIssueKey.tsx';
import type { GraphQlResponse } from '@jira/issue__fetch-services/src/ForgeResponse.types.tsx';
import type { RouterDataContext, ResourceStoreContext } from '@atlassian/react-resource-router';
import { fg } from '@atlassian/jira-feature-gating';

const getData = async (
	routerContext: RouterDataContext,
	_storeContext: ResourceStoreContext,
): Promise<GraphQlResponse | null> => {
	let issueKey = getIssueKey(routerContext.match);

	if (
		!issueKey &&
		(fg('nin_glance_panel_technical_changes') || fg('nin_issue_app_conditional_entrypoint'))
	) {
		issueKey = routerContext.query?.selectedIssue ?? '';
	}

	if (!issueKey) {
		return null;
	}

	try {
		const data = await fetchIssueGiraData(issueKey);
		return data;
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		throw createResourceError(
			{
				component: 'spa.view.routes.issue-view.gira.getData',
				message: 'An error was thrown while prefetching issue gira data',
				name: 'ResourceError',
			},
			error,
		);
	}
};

export default getData;
